interface IndexItem {
  image: string;
  imageAlt: string;
  title: string;
  count: string;
  desc: string;
}

const indexItems: IndexItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Entertainment%20gossip%20themed%20abstract%20collage%20with%20microphone%20and%20spotlight%2C%20warm%20coral%20and%20amber%20tones%2C%20modern%20editorial%20style%2C%20clean%20composition&width=400&height=300&seq=index-01-91cg&orientation=landscape",
    imageAlt: "明星八卦合集",
    title: '明星八卦一周汇总',
    count: '48个视频',
    desc: '本周最劲爆的明星花边、恋情实锤和综艺内幕，一次性看完。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Social%20media%20trending%20topics%20abstract%20visualization%20with%20floating%20hashtags%2C%20warm%20rose%20and%20amber%20tones%2C%20modern%20editorial%20design%2C%20clean%20composition&width=400&height=300&seq=index-02-91cg&orientation=landscape",
    imageAlt: "社会热点追踪",
    title: '社会热点深度追踪',
    count: '36个视频',
    desc: '全网热议的社会事件视频合集，从多个视角还原事件全貌。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Internet%20celebrity%20live%20streaming%20themed%20abstract%20illustration%20with%20smartphone%20and%20ring%20light%2C%20warm%20amber%20and%20terracotta%20tones%2C%20editorial%20style&width=400&height=300&seq=index-03-91cg&orientation=landscape",
    imageAlt: "网红动态一览",
    title: '网红圈风云录',
    count: '52个视频',
    desc: '直播圈、短视频圈的翻车事件和成名故事，吃瓜不停歇。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Variety%20show%20stage%20abstract%20themed%20illustration%20with%20colorful%20lights%2C%20warm%20coral%20tones%2C%20modern%20editorial%20design%2C%20clean%20composition&width=400&height=300&seq=index-04-91cg&orientation=landscape",
    imageAlt: "综艺内幕揭秘",
    title: '综艺幕后大揭秘',
    count: '29个视频',
    desc: '热门综艺录制花絮、幕后故事和未播片段独家放送合集。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=International%20celebrity%20news%20abstract%20collage%20with%20global%20map%20elements%2C%20warm%20dark%20background%2C%20modern%20editorial%20style%2C%20clean%20composition&width=400&height=300&seq=index-05-91cg&orientation=landscape",
    imageAlt: "海外吃瓜精选",
    title: '海外吃瓜精选集',
    count: '25个视频',
    desc: '欧美日韩娱乐圈最新动态，国际巨星八卦一网打尽。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Film%20industry%20themed%20abstract%20illustration%20with%20movie%20clapperboard%2C%20warm%20amber%20and%20rose%20tones%2C%20editorial%20photography%20style%2C%20clean%20composition&width=400&height=300&seq=index-06-91cg&orientation=landscape",
    imageAlt: "影视吐槽大会",
    title: '影视剧吐槽大会',
    count: '41个视频',
    desc: '最新上映影视剧热门吐槽和深度解读，看片前必刷。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Annual%20entertainment%20review%20abstract%20themed%20collage%20with%20calendar%20elements%2C%20warm%20coral%20tones%2C%20modern%20editorial%20design%2C%20clean%20composition&width=400&height=300&seq=index-07-91cg&orientation=landscape",
    imageAlt: "年度大瓜回顾",
    title: '2026上半年大瓜盘点',
    count: '63个视频',
    desc: '今年最轰动的吃瓜事件完整回顾，每一件都曾刷爆你的朋友圈。',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-2">专题合集</h2>
        <p className="text-foreground-500 text-sm text-center mb-10">按主题分类浏览，快速找到你感兴趣的吃瓜内容</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute bottom-3 left-3 text-white text-xs font-medium bg-black/40 px-2 py-1 rounded-full whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 mb-1 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}